module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABH0lEQVRIS93UvUoEMRTF8f8pLAUrEQQfwxfwPWy1lAU/Vl2EVXFXEDsrwXcRfBBBULEUbI+M7MIYJ5PMhG1Mndzf5SY5YsFLC67PL8D2NrBciH5JepjXCIEXYL0Q+JC0GgOegY1C4F3SWgzYB1YKgU9Jk0agsHDj8U6vyPYUWJI0yG0mG7A9BkazwhNJwxwkC7B9CRwHBbOQJBB0HjadRFoB2+fAaWIUU0lHsT1RwPYFcJIzZ+BKUjjCn6ONQMfi8x6uJR2GDf0BehaPImEW7QC7gGcnqkxJZdMr8Fbr/F7SXdZPtr0H3CbuYViPhuSI6htsVz/2JgGMJFUPontU/AvgAKgCrm2NJZ31HdEmsJUAHiU99QIyf3HrtmTYlSLfa0NhGZ8RAR4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hover_btn_top_pre(1).png
// module id = SIVN
// module chunks = 1